import React, { Component } from "react";
import {
  Container,
} from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";



const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";



export default class AddReceiptLinePalletsGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataReady: false

    };
    // this.dataReady = false;
    this.columnDefs = this.createColumnDefs();

    this.onGridReady = this.onGridReady.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);

  }



  onGridReady(params){
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit(); 
    this.setState({dataReady: true});
    //this.gridApi.getDisplayedRowAtIndex(0).setSelected(true);   
  }

  createColumnDefs() {
    /*
    var modelScaffold = new ReceiptLinePalletEditorModel();
    var modelDefs = Object.getOwnPropertyNames(modelScaffold);
    var columnDefs = [];
    modelDefs.forEach(el => {
      columnDefs.push({ headerName: el, field: el })
    });
    */
   var columnDefs = [
    {headerName: "Id", field: "glasschainId", sortable: false, filter: false, resizable: true, maxWidth: 100},
    {headerName: "Qty", field: "actualPalletUnitQty", sortable: true, filter: false, resizable: true, maxWidth: 120, type: "numericColumn"}
   ];
    return columnDefs;
  }


  onSelectionChanged(){
    var selectedNodes = this.gridApi.getSelectedNodes();
    if (!selectedNodes) return;
    if (!selectedNodes[0]) return;
    var rowData = selectedNodes[0].data;
    this.setState({ selectedRow: rowData});
    this.props.onPalletSelectionChange(rowData);
  }


  render() {


    const divStyle = {
      width: "100%",
      height: "calc(25vh)",

      margin: "5px",
      //border: '5px solid black'
    };

    if (this.state.dataReady){
      this.gridApi.setRowData((this.props.rowData) ? this.props.rowData: []);
    }

    return (
            <div style={{ width: "100%", height: "100%" }}>
              <Container fluid>
                <div className="ag-theme-balham" style={divStyle}>
                  <AgGridReact
                    rowSelection="single"
                    enableRangeSelection={true}
                    pagination={false}
                    columnDefs={this.columnDefs}
                    rowData={this.props.rowData}
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    onSelectionChanged={this.onSelectionChanged}
                    immutableData={true}
                    getRowNodeId={(data) => data.glasschainId}
                  />
                </div>

              </Container>
            </div>
    );
  }
}
